import React from 'react'

export default function Tips({amount, values, onSelected, onCustom, onCancel}) {
  const percents = values.split(', ')

  const percentButtons = () => {
    return percents.map(percent => {
      const value = (amount / 100) * percent
      const roundedValue = parseFloat(value).toFixed(2)

      return <div className='tip-button percent-button' key={percent} onClick={() => onSelected(roundedValue)}>
        <span className='percent'>{`${percent} %`}</span>
        <span className='amount'>{`$${roundedValue}`}</span>
      </div>
    })
  }

  return <div className='tip-content'>
    <div className='tip-header'>
      <div className='amount'>{`$${parseFloat(amount).toFixed(2)}`}</div>
      <div className='add-label'>Add a tip</div>
    </div>

    <div className='tip-body'>
      <div className='percents'>{percentButtons()}</div>
      <div className='tip-button tip-option' onClick={onCustom}>Custom Tip Amount</div>
      <div className='tip-button tip-option' onClick={() => onSelected('')}>No Tip</div>
      <div className='tip-button tip-option cancel' onClick={onCancel}>Cancel</div>
    </div>
  </div>
}
